import { v4 as uuidv4 } from "uuid";

// Construction / Project-Wrap class + payroll recommendation.
// Mirrors the FSE "Rating and Pricing - Project and Wrap" workbook:
//   estimated payroll per class = Construction Value
//     x state payroll-to-CV ratio ("Payroll to Value by State"!E)
//     x project-type payroll mix (ProjectWrapLookups B9:E29).
// The factor tables (project types, insured interests, state payroll-to-CV
// ratios, class mix) live in the `construction_rating_config` static-data
// config and are passed in as `cfg`.

// Recommended GL exposure rows { state, class_code, exposure_amount } for the
// construction inputs. exposure_amount is the estimated payroll for the class.
// State ratios + class mix come from the construction_rating_config config.
export const recommendClasses = (
  state,
  projectType,
  constructionValue,
  cfg = {}
) => {
  const ratio = (cfg.statePayrollCvRatio ?? {})[state];
  const mix = (cfg.classMixByProjectType ?? {})[projectType];
  const cv = Number(constructionValue) || 0;
  if (!ratio || !mix || cv <= 0) return [];
  const totalPayroll = cv * ratio;
  return Object.entries(mix).map(([class_code, share]) => ({
    state,
    class_code,
    exposure_amount: Math.round(totalPayroll * share),
  }));
};

// Values to commit to the GL Pricing factors when copying a recommendation.
// Project type + insured interest default from the recommender's own selections
// (construction* fields), but never overwrite a value the user set directly on
// the GL Pricing tab (tracked by the *Manual flags — "GL Pricing wins").
export const projectWrapPricingCommit = (program = {}) => {
  const commit = {};
  if (!program.projectTypeManual && program.constructionProjectType) {
    commit.projectType = program.constructionProjectType;
  }
  if (!program.insuredInterestManual && program.constructionInsuredInterest) {
    commit.insuredInterest = program.constructionInsuredInterest;
  }
  return commit;
};

// GL exposure input rows (with ids) for the recommended classes.
export const toExposureRows = (recommended) =>
  recommended.map((r) => ({
    id: uuidv4(),
    state: r.state,
    classCode: r.class_code,
    exposureAmount: r.exposure_amount,
  }));
